module.exports = __webpack_public_path__ + "static/media/20240130084050_IMG_5077 (1).2fd8b973.jpg";